// extracted by mini-css-extract-plugin
export var caseStudy = "case-study-card-module--caseStudy--4a781";
export var content = "case-study-card-module--content--cdb95";
export var description = "case-study-card-module--description--b616d";
export var image = "case-study-card-module--image--728a8";
export var tag = "case-study-card-module--tag--e37a1";
export var tagContainer = "case-study-card-module--tagContainer--7bba1";
export var tags = "case-study-card-module--tags--464b4";
export var title = "case-study-card-module--title--16116";